const randomNumBetween = (min: number, max: number) =>
    Math.random() * (max - min) + min;

interface ShapePosition {
    x: number;
    y: number;
}

interface ShapeArgs {
    lineWidth: string;
    lineColor: string;
    fillColor: string;
    start: any;
    bezier: any;
    position: ShapePosition;
}

export default class Shape {
    private position: ShapePosition;
    private updatedPosition: ShapePosition;
    private velocity: ShapePosition;
    private distance: number;
    private lineWidth: string;
    private lineColor: string;
    private fillColor: string;
    private start: any;
    private bezier: any;

    constructor(args: ShapeArgs) {
        this.position = args.position;
        this.lineWidth = args.lineWidth;
        this.lineColor = args.lineColor;
        this.fillColor = args.fillColor;
        this.start = args.start;
        this.bezier = args.bezier;
        this.updatedPosition = {
            x: this.position.x,
            y: this.position.y,
        };
        this.velocity = {
            x: randomNumBetween(-0.2, 0.2),
            y: randomNumBetween(-0.2, 0.2),
        };
        this.distance = 45;
    }

    render(state: any) {
        this.updatedPosition.x = this.updatedPosition.x + this.velocity.x;
        this.updatedPosition.y = this.updatedPosition.y + this.velocity.y;

        if (
            this.updatedPosition.x >= this.position.x + this.distance ||
            this.updatedPosition.x <= this.position.x - this.distance
        ) {
            this.velocity.x = this.velocity.x * -1;
            this.updatedPosition.x = this.updatedPosition.x + this.velocity.x;
        }
        if (
            this.updatedPosition.y >= this.position.y + this.distance ||
            this.updatedPosition.y <= this.position.y - this.distance
        ) {
            this.velocity.y = this.velocity.y * -1;
            this.updatedPosition.y = this.updatedPosition.y + this.velocity.y;
        }
        // Draw
        const { context } = state;
        context.save();
        if (this.lineWidth !== "") {
            context.lineWidth = this.lineWidth;
            context.strokeStyle = this.lineColor;
        }
        if (this.fillColor !== "") {
            context.fillStyle = this.fillColor;
        }
        context.beginPath();
        context.moveTo(
            this.start[0] + this.updatedPosition.x,
            this.start[1] + this.updatedPosition.y
        );
        this.bezier.forEach((thisShape: any, i: number) => {
            if (this.bezier[i].length === 6) {
                context.bezierCurveTo(
                    this.bezier[i][0] + this.updatedPosition.x,
                    this.bezier[i][1] + this.updatedPosition.y,
                    this.bezier[i][2] + this.updatedPosition.x,
                    this.bezier[i][3] + this.updatedPosition.y,
                    this.bezier[i][4] + this.updatedPosition.x,
                    this.bezier[i][5] + this.updatedPosition.y
                );
            }
        });
        if (this.fillColor !== "") {
            context.fill();
        }
        context.closePath();
        context.restore();
    }
}
